import { Alert, Box } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getLocalStorageValue,
  setLocalStorageValue,
} from "../../utils/localStorage";
import { loginTeacherSchema } from "../../schema/teacherSchema";
import { loginTeacher } from "../../api/teacher";
import { mockTeacherLoginFields } from "../../data/mockTeacherData";
import AuthLayout from "../global/AuthLayout";
import FormFooter from "../shared/FormFooter";
import AuthForm from "../shared/AuthForm";

const initialValues = {
  email: "",
  password: "",
};

const TeacherLogin = () => {
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const result = getLocalStorageValue("teacher");
    if (result) {
      navigate("/teacherDashboard");
    }
  }, [navigate]);

  const handleFormSubmit = useCallback(async (values) => {
    try {
      const teacherData = await loginTeacher(values);
      setLocalStorageValue("teacher", teacherData);
      navigate("/teacherDashboard");
    } catch (error) {
      setErrorMessage(error.message);
      setIsError(true);
      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  }, [navigate]);

  return (
    <AuthLayout title="Login Teacher">
      {isError && (
        <Box my={2}>
          <Alert variant="filled" severity="error">
            {errorMessage}
          </Alert>
        </Box>
      )}
      <AuthForm
        initialValues={initialValues}
        validationSchema={loginTeacherSchema}
        fields={mockTeacherLoginFields}
        onSubmit={handleFormSubmit}
      >
        <FormFooter
          text="If you don't have any account"
          link="teacherRegister"
          linkText="register"
          buttonText="Login Teacher"
        />
      </AuthForm>
    </AuthLayout>
  );
};

export default TeacherLogin;
